/* eslint-disable unicorn/no-null */
import type { ApiClientConfig } from '@newo/api-client';
import useAppStore from '@/store/app';

type StorageAdapter = ApiClientConfig['storage'];

const STORAGE_KEY_ACCESS_TOKEN = 'accessToken';
const STORAGE_KEY_REFRESH_TOKEN = 'refreshToken';
const STORAGE_KEY_TOKEN_EXPIRES_AT = 'tokenExpiresAt';

export const zustandStorageAdapter: StorageAdapter = {
    get(key) {
        const state = useAppStore.getState();

        if (key === STORAGE_KEY_ACCESS_TOKEN) {
            return state.accessToken ?? null;
        }

        if (key === STORAGE_KEY_REFRESH_TOKEN) {
            return state.refreshToken ?? null;
        }

        if (key === STORAGE_KEY_TOKEN_EXPIRES_AT) {
            return state.expireAt ? String(state.expireAt) : null;
        }

        return null;
    },
    set(key, value) {
        if (key === STORAGE_KEY_ACCESS_TOKEN) {
            useAppStore.setState({ accessToken: value, isAuthorized: true });
            return;
        }

        if (key === STORAGE_KEY_REFRESH_TOKEN) {
            useAppStore.setState({ refreshToken: value });
            return;
        }

        if (key === STORAGE_KEY_TOKEN_EXPIRES_AT) {
            useAppStore.setState({
                expireAt: Number(value),
                lastTimeUpdateAt: Date.now()
            });
        }
    },
    remove(key) {
        if (key === STORAGE_KEY_ACCESS_TOKEN) {
            useAppStore.setState({
                accessToken: undefined,
                isAuthorized: false
            });
            return;
        }

        if (key === STORAGE_KEY_REFRESH_TOKEN) {
            useAppStore.setState({ refreshToken: undefined });
            return;
        }

        if (key === STORAGE_KEY_TOKEN_EXPIRES_AT) {
            useAppStore.setState({ expireAt: 0 });
        }
    }
};
